import API from "@/services/api";
import { 
  IFetchContractsResponse, 
  IFetchContractsParams,
  ExportContractResponse,
  Contract
} from "../types/contracts";
import { IUpdateRefCatastral, IUpdateRefCatastralAPIParams, IUpdateRefCatastralSucessResponse } from "../types/refCatastral";
import { IUpdateInvoiceOnline, IUpdateInvoiceOnlineAPIParams, IUpdateInvoiceOnlineSucessResponse } from "../types/invoiceOnline";
import { ChangeContractNotificationField, ChangeContractNotificationFieldResponse, ChangeContractNotificationFieldAPIData} from "../types/changeContractNotificationField";

export enum EndpointName {
  Contracts = '/contracts',
  ExportContract = '/contracts/:contractName/pdf/',
  UpdateRefCatastral = '/contracts/:contractName/ref_catastral/',
  UpdateInvoiceOnline = "/contracts/:contractName/",
  UpdateNotificationField = '/contracts/:contractName/notification/:field/'
}

const fetchContracts = <ContractType extends Contract,>({
  initial=false, 
  type="electricity",
  offset=0, 
  limit=100, 
  filter=''
}: IFetchContractsParams) => {
  return API.get<IFetchContractsResponse<ContractType>>({
    endpoint: EndpointName.Contracts,
    versions: [2],
    searchParams: [
				'?initial', '=', initial,
				'&offset', '=', offset,
				'&limit', '=', limit,
				'&filter', '=', filter,
        '&type', '=', type
			].join('')
  });
}

const exportElectricityContract = (contractName: string, lang: string) => {
  return API.get<ExportContractResponse>({
    endpoint: EndpointName.ExportContract,
    versions: [1],
    params: {
      contractName
    },
    searchParams: `?lang=${lang}`,
    config: {responseType: "blob"}
  });
}

const exportGasContract = (contractName: string, lang: string) => {
  return API.get<ExportContractResponse>({
    endpoint: EndpointName.ExportContract,
    versions: [2],
    params: {
      contractName
    },
    searchParams: `?lang=${lang}`,
    config: {responseType: "blob"}
  });
}

const updateRefCatastral = ({
  refCatastral,
  contractName,
  type
}: IUpdateRefCatastral) => {
  return API.put<IUpdateRefCatastralSucessResponse, IUpdateRefCatastralAPIParams>({
    endpoint: EndpointName.UpdateRefCatastral,
    versions: [2],
    data: {
      ref_catastral: refCatastral
    },
    searchParams: `?type=${type}`,
    params: {
      contractName
    }
  });
}

const updateInvoiceOnline = ({
  sendMethod,
  contractName,
  type
}: IUpdateInvoiceOnline) => {
  return API.post<IUpdateInvoiceOnlineSucessResponse, IUpdateInvoiceOnlineAPIParams>({
    endpoint: EndpointName.UpdateInvoiceOnline,
    versions: [2],
    data: {
      invoice_online: sendMethod
    },
    searchParams: `?type=${type}`,
    params: {
      contractName
    }
  });
}

export const updateContractNotificationField = (
  props: ChangeContractNotificationField
) => {
  return new Promise<ChangeContractNotificationFieldResponse>(async (resolve, reject) => {
    API.put<ChangeContractNotificationFieldResponse, ChangeContractNotificationFieldAPIData>({
      endpoint: EndpointName.UpdateNotificationField,
      params: {
        contractName: props.contractName,
        field: props.field,
      },
      data: {
        [props.field]: props.value
      }
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}

export default {
  fetchContracts,
  exportContract: {
    electricity: exportElectricityContract,
    gas: exportGasContract
  },
  updateRefCatastral,
  updateInvoiceOnline,
  updateContractNotificationField
};